// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"596bba5b","991":"a119304b"}[chunkId] + ".chunk.js";
};